import { rgba } from 'polished';

var colorShadow = '#00143c';

export var depth100 = '0 0 6px 0 ' + rgba(colorShadow, 0.1);
export var depth150 = '0 1px 2px 0 ' + rgba(colorShadow, 0.3);
export var depth200 = '0 3px 6px 0 ' + rgba(colorShadow, 0.16) + ', 0 3px 6px 0 ' + rgba(colorShadow, 0.23);
export var depth300 = '0 10px 20px 0 ' + rgba(colorShadow, 0.19) + ', 0 6px 6px 0 ' + rgba(colorShadow, 0.23);
export var depth400 = '0 14px 28px 0 ' + rgba(colorShadow, 0.25) + ', 0 10px 10px 0 ' + rgba(colorShadow, 0.22);
export var depth500 = '0 19px 38px 0 ' + rgba(colorShadow, 0.3) + ', 0 15px 12px 0 ' + rgba(colorShadow, 0.22);
export var depth600 = '0 0 6px 0 ' + colorShadow;